namespace $.$$ {
	
	$mol_style_define( $mol_chip, {
		
		padding: $mol_gap.text,
		
		border: {
			radius: $mol_gap.round,
		},

		background: {
			color: $mol_theme.card,
		},
		
		gap: $mol_gap.block,
		
	} )
	
}
